import Header from "../common/Header";
import Sidebar from "../common/Sidebar";

export default function CreditCard() {
  return (
    <>
      <Header />
      <div className="adminuiux-wrap">
        <Sidebar />
        <main
  className="adminuiux-content has-sidebar"
>
  {/*mt-4*/}
  <div className="container " id="main-content">
    <div className="row align-items-center">
      {/* <div class="col-6 col-sm-4 col-lg-3 col-xl-2 mb-4">
                  <div class="card adminuiux-card">
                      <div class="card-body">
                          <p class="text-secondary small mb-2">Total Profit</p>
                          <h4 class="mb-3">$13.20k</h4><span class="badge badge-light text-bg-success"><i class="me-1 bi bi-arrow-up-short"></i>28.50%</span></div>
                  </div>
              </div>
              <div class="col-6 col-sm-4 col-lg-3 col-xl-2 mb-4">
                  <div class="card adminuiux-card">
                      <div class="card-body">
                          <p class="text-secondary small mb-2">Best Profit</p>
                          <h4 class="mb-3">$8.34k</h4><span class="badge badge-light text-bg-success"><i class="me-1 bi bi-arrow-up-short"></i>54.35%</span></div>
                  </div>
              </div>
              <div class="col-12 col-sm-4 col-lg-3 col-xl-2 mb-4">
                  <div class="card adminuiux-card">
                      <div class="card-body">
                          <p class="text-secondary small mb-2">Top Loser</p>
                          <h4 class="mb-3">-$5.15k</h4><span class="badge badge-light text-bg-danger"><i class="me-1 bi bi-arrow-down-short"></i>18.25%</span></div>
                  </div>
              </div> */}
    </div>
    <input type="hidden" id="mtime" />
    <input type="hidden" id="sta" />
    <input type="hidden" id="my_limit" />
    <input type="hidden" id="sender_id" />
    <input
      type="hidden"
      name="_token"
      defaultValue="DGyDvczUJzdSGbFAAxNsYxRPRNHBwoUIvt2tJL1u"
    />
    {/* dashboard inner */}
    <div className="midde_cont">
      <div className="container-fluid">
        <div className="row column_title">
          <div className="col-md-12">
            <div className="page_title d-sm-flex">
              <h2>Dashboard</h2>
              <marquee>
                <h4 />
              </marquee>
            </div>
          </div>
        </div>
        <div className="row row-sm" id="sender-search-box">
          <div className="col-md-6">
            <div className="card adminuiux-card bd-0 shadow-base">
              <div
                className="card-header tx-medium bd-0 tx-white"
                style={{ padding: "0.75rem 1.25rem" }}
              >
                Search Customer
              </div>
              {/* card-header */}
              <div className="card-body">
                <fieldset noValidate="">
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Sender Number"
                      id="sender_number"
                      aria-describedby="button-addon2"
                      autoComplete="off"
                      maxLength={10}
                    />
                    <div className="input-group-append" id="button-addon2">
                      <button
                        className="btn btn-primary waves-effect waves-light"
                        onclick="mobile_verify()"
                        type="button"
                        id="mobile_verify_btn"
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </fieldset>
              </div>
              {/* card-body */}
            </div>
            {/* card */}
          </div>
          {/* card */}
        </div>
        <div
          className="row row-sm"
          id="account_Details_box"
          style={{ display: "none" }}
        >
          <div className="col-md-6" />
          <div className="col-md-6">
            <div className="card adminuiux-card bd-0 shadow-base">
              <div
                className="card-header tx-medium bd-0 tx-white"
                style={{ padding: "0.75rem 1.25rem" }}
              >
                Beneficiary Account Found{" "}
              </div>
              {/* card-header */}
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-borderless mb-0 tx-12">
                    <thead>
                      <tr>
                        <th>Sender Mobile</th>
                        <th>Beneficiary Name</th>
                        <th>Account Number</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody id="bene_list_by_account"></tbody>
                  </table>
                </div>
              </div>
              {/* card-body */}
            </div>
            {/* card */}
          </div>
          {/* card */}
        </div>
        <div className="row" style={{ display: "none" }} id="sender_detail">
          <div className="col-md-12">
            <div className="card adminuiux-card">
              <div className="card-content">
                <div className="card-body pb-0">
                  <div className="row" style={{ padding: "0.55rem 1.25rem" }}>
                    <div className="col-md-6">
                      <h4>
                        Remitter :
                        <span id="sender_name_text" />
                      </h4>
                    </div>
                    <div className="col-md-6">
                      <h4>
                        Mobile :
                        <span id="sender_number_text" />
                      </h4>
                    </div>
                    {/*<div class="col-md-6">*/}
                    {/*    <h4>*/}
                    {/*        Limit :*/}
                    {/*        <span id="paytm_limit_text"></span>*/}
                    {/*    </h4>*/}
                    {/*</div>*/}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row" style={{ display: "none" }} id="search_account">
          <div className="col-md-12">
            <div className="card adminuiux-card">
              <div className="card-content">
                <div className="card-body pb-0">
                  <div className="row mb-3">
                    <div className="col-md-6 col-12 mb-1">
                      <fieldset>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Account No"
                            id="saccount"
                            aria-describedby="button-addon2"
                          />
                          <div
                            className="input-group-append"
                            id="button-addon2"
                          >
                            <button
                              className="btn btn-primary waves-effect waves-light"
                              onclick="bene_list('0')"
                              type="button"
                            >
                              Search
                            </button>
                          </div>
                          &nbsp;
                          <button
                            className="btn btn-primary waves-effect waves-light"
                            onclick="bene_list('1')"
                            type="button"
                          >
                            View All
                          </button>
                          &nbsp;
                          <button
                            className="btn btn-primary waves-effect waves-light"
                            onclick="add_card()"
                            type="button"
                          >
                            Add Card
                          </button>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="row match-height"
          style={{ display: "none" }}
          id="main_box"
        >
          <div className="col-12">
            <div className="form-body">
              <div className="row">
                <div className="col-md-6 col-sm-12 col-xs-12">
                  <div style={{ display: "none" }} id="add_bene_box">
                    <div className="card adminuiux-card bd-0 shadow-base">
                      <div
                        className="card-header tx-medium bd-0 tx-white"
                        style={{ padding: "0.75rem 1.25rem" }}
                      >
                        Add Card
                      </div>
                      <div className="card-body">
                        <label htmlFor="email-id-vertical">Bank</label>
                        <div className="form-group">
                          <select
                            id="bank_name"
                            className="form-control js-example-basic-single select2-hidden-accessible"
                            style={{ width: "100%" }}
                            onchange="get_ifsc()"
                            data-select2-id="select2-data-bank_name"
                            tabIndex={-1}
                            aria-hidden="true"
                          >
                            <option
                              value=""
                              data-select2-id="select2-data-2-clmt"
                            >
                              Select
                            </option>
                            <option value="Bank of Baroda Credit Card">
                              Bank of Baroda Credit Card
                            </option>
                            <option value="CREDIT CARD - AMERICAN EXPRESS">
                              CREDIT CARD - AMERICAN EXPRESS
                            </option>
                            <option value="CREDIT CARD - Barclays">
                              CREDIT CARD - Barclays
                            </option>
                            <option value="CREDIT CARD - Citibank">
                              CREDIT CARD - Citibank
                            </option>
                            <option value="CREDIT CARD - HDFC Bank">
                              CREDIT CARD - HDFC Bank
                            </option>
                            <option value="CREDIT CARD - HSBC">
                              CREDIT CARD - HSBC
                            </option>
                            <option value="CREDIT CARD - ICICI Bank">
                              CREDIT CARD - ICICI Bank
                            </option>
                            <option value="CREDIT CARD - Kotak Mahindra Bank">
                              CREDIT CARD - Kotak Mahindra Bank
                            </option>
                            <option value="CREDIT CARD - SBI">
                              CREDIT CARD - SBI
                            </option>
                            <option value="CREDIT CARD - Standard Chartered">
                              CREDIT CARD - Standard Chartered
                            </option>
                            <option value="CREDIT CARD - Vijaya Bank">
                              CREDIT CARD - Vijaya Bank
                            </option>
                            <option value="CREDIT CARD -Axis Bank">
                              CREDIT CARD -Axis Bank
                            </option>
                            <option value="IDFC FIRST Bank Credit card">
                              IDFC FIRST Bank Credit card
                            </option>
                            <option value="IndusInd Bank Credit Card">
                              IndusInd Bank Credit Card
                            </option>
                            <option value="RBL- CREDIT CARD">
                              RBL- CREDIT CARD
                            </option>
                            <option value="YES BANK Credit Card">
                              YES BANK Credit Card
                            </option>
                          </select>
                          <span
                            className="select2 select2-container select2-container--default"
                            dir="ltr"
                            data-select2-id="select2-data-1-9gkz"
                            style={{ width: "100%" }}
                          >
                            <span className="selection">
                              <span
                                className="select2-selection select2-selection--single"
                                role="combobox"
                                aria-haspopup="true"
                                aria-expanded="false"
                                tabIndex={0}
                                aria-disabled="false"
                                aria-labelledby="select2-bank_name-container"
                                aria-controls="select2-bank_name-container"
                              >
                                <span
                                  className="select2-selection__rendered"
                                  id="select2-bank_name-container"
                                  role="textbox"
                                  aria-readonly="true"
                                  title="Select"
                                >
                                  Select
                                </span>
                                <span
                                  className="select2-selection__arrow"
                                  role="presentation"
                                >
                                  <b role="presentation" />
                                </span>
                              </span>
                            </span>
                            <span
                              className="dropdown-wrapper"
                              aria-hidden="true"
                            />
                          </span>
                        </div>
                        <div className="form-group mt-2">
                          <label>Account Number</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Account No"
                            readOnly=""
                            id="account_number"
                          />
                        </div>
                        <div className="form-group mt-2">
                          <label>IFSC Code</label>
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              id="ifsc_code"
                              placeholder="IFSC Code"
                              aria-label="IFSC Code"
                              aria-describedby="button-addon2"
                            />
                            <div className="input-group-append">
                              <button
                                className="btn btn-primary"
                                id="button-addon2"
                                onclick="get_ifsc()"
                              >
                                Get IFSC
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="form-group mt-2">
                          <label>Beneficiary Name</label>
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              id="bene_name"
                              placeholder="Bene Name"
                              aria-label="Bene Name"
                              aria-describedby="button-addon2"
                            />
                          </div>
                        </div>
                        <input
                          type="hidden"
                          id="bene_veriry"
                          defaultValue={0}
                        />
                        <button
                          type="submit"
                          onclick="add_beneficiary()"
                          className="btn btn-sm btn-primary mr-1 mb-1 waves-effect waves-light mt-2"
                        >
                          Add Beneficiary
                        </button>
                      </div>
                    </div>
                  </div>
                  {/*add bene close div*/}
                </div>
                <div className="col-md-8 col-sm-12 col-xs-12">
                  <div className="row">
                    <div className="col-md-6">
                      <input type="hidden" id="fucking_id" />
                      <div style={{ display: "none" }} id="add_sender_box">
                        {/*add sender start div*/}
                        <div className="form-group">
                          <label>Sender Name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Full Name"
                            id="full_name"
                          />
                        </div>
                        <div className="form-group mt-2">
                          <label>Otp</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Otp"
                            id="otp"
                          />
                        </div>
                        <button
                          type="submit"
                          className="btn btn-sm btn-primary mr-1 mb-1 waves-effect waves-light mt-2"
                          onclick="add_sender()"
                        >
                          Submit
                        </button>
                        <button
                          type="submit"
                          className="btn btn-sm btn-danger mr-1 mb-1 waves-effect waves-light mt-2"
                          onclick="resend_otp()"
                        >
                          Resnd OTP
                        </button>
                      </div>
                      {/*add sender close div*/}
                    </div>
                  </div>
                </div>
                <div className="col-md-8 col-sm-12 col-xs-12" />
                <div className="col-md-8 col-sm-12 col-xs-12" />
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <div
                    className="card adminuiux-card"
                    id="account_Details_box"
                    style={{ display: "none" }}
                  >
                    <span>Search By Account Number</span>
                    <div className="card-content">
                      <div className="table-responsive">
                        <table className="table table-borderless mb-0 tx-12">
                          <thead>
                            <tr>
                              <th>Sender Mobile</th>
                              <th>Beneficiary Name</th>
                              <th>Account Number</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody id="bene_list_by_account"></tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div
                    className="card adminuiux-card bd-0 shadow-base mt-5"
                    style={{ display: "none" }}
                    id="bene_list_box"
                  >
                    <div
                      className="card-header tx-medium bd-0 tx-white"
                      style={{ padding: "0.75rem 1.25rem" }}
                    >
                      Card Beneficiary List{" "}
                      <b
                        className="tx-danger tx-center ml-5 bg-white p-1 border border-danger"
                        id="balMsg"
                        style={{ display: "none" }}
                      />
                    </div>
                    {/* card-header */}
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Bank Name</th>
                              <th>Account No</th>
                              <th>Ifsc</th>
                              <th>Amount</th>
                              <th>IMPS</th>
                              <th>NEFT</th>
                            </tr>
                          </thead>
                          <tbody id="bene_list"></tbody>
                        </table>
                      </div>
                    </div>
                    {/* card-body */}
                  </div>
                  {/* card */}
                  <div
                    className="card adminuiux-card"
                    style={{ display: "none" }}
                    id="upi_bene_list_box"
                  >
                    <span>Upi List</span>{" "}
                    <b
                      className="tx-danger tx-center"
                      id="upibalMsg"
                      style={{ display: "none" }}
                    />
                    <div className="card-content">
                      <div className="table-responsive">
                        <table className="table table-borderless mb-0 tx-15">
                          <thead>
                            <tr>
                              <th>Verify</th>
                              <th>Bene Name</th>
                              <th>Upi Address</th>
                              <th>Bene Mobile</th>
                              <th>Amount</th>
                              <th>Upi Transfer</th>
                            </tr>
                          </thead>
                          <tbody id="upi_bene_list"></tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="position-fixed bottom-0 end-0 m-3 z-index-5">
      {/*<button class="btn btn-square btn-theme shadow" type="button" data-bs-toggle="offcanvas" data-bs-target="#theming" aria-controls="theming"><i class="bi bi-palette"></i></button>*/}
      <br />
      <button
        className="btn btn-theme btn-square rounded-circle shadow mt-2 d-none"
        id="backtotop"
      >
        <i className="bi bi-arrow-up" />
      </button>
    </div>
    <div
      className="offcanvas offcanvas-end shadow border-0"
      tabIndex={-1}
      id="theming"
      data-bs-scroll="true"
      data-bs-backdrop="false"
      aria-labelledby="theminglabel"
    >
      <div className="offcanvas-header border-bottom">
        <div>
          <h5 className="offcanvas-title" id="theminglabel">
            Personalize
          </h5>
          <p className="text-secondary small">Make it more like your own</p>
        </div>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        />
      </div>
      <div className="offcanvas-body">
        <h6 className="offcanvas-title">Colors</h6>
        <p className="text-secondary small mb-4">Change colors of templates</p>
        <div className="row mb-4 theme-select">
          <div className="col-auto">
            <div className="select-box text-center mb-2" data-title="">
              <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                <i className="bi bi-arrow-clockwise" />
              </span>
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-blue"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-blue" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-indigo"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-indigo" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-purple"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-purple" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-pink"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-pink" />
            </div>
          </div>
          <div className="col-auto">
            <div className="select-box text-center mb-2" data-title="theme-red">
              <span className="avatar avatar-40 rounded-circle mb-2 bg-red" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-orange"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-orange" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-yellow"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-yellow" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-green"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-green" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-teal"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-teal" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-cyan"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-cyan" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-grey"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-grey" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-brown"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-brown" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-chocolate"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-chocolate" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-black"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-dark" />
            </div>
          </div>
        </div>
        <h6 className="offcanvas-title">Backgrounds</h6>
        <p className="text-secondary small mb-4">Change color for background</p>
        <div className="row mb-4 theme-background">
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-default"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                <i className="bi bi-arrow-clockwise" />
              </span>
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-white"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-white" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-r-gradient"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-r-gradient" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-gradient-1"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-1" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-gradient-2"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-2" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-gradient-3"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-3" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-gradient-4"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-4" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-gradient-5"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-5" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-gradient-6"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-6" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-gradient-7"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-7" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-gradient-8"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-8" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-gradient-9"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-9" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-gradient-10"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-10" />
            </div>
          </div>
        </div>
        <h6 className="offcanvas-title">Sidebar Layout</h6>
        <p className="text-secondary small mb-4">Change sidebar layout style</p>
        <div className="row mb-4 sidebar-layout">
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="adminuiux-sidebar-standard"
              data-bs-toggle="tooltip"
              aria-label="None"
              data-bs-original-title="None"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                <i className="bi bi-arrow-clockwise" />
              </span>
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="adminuiux-sidebar-iconic"
              data-bs-toggle="tooltip"
              aria-label="Iconic"
              data-bs-original-title="Iconic"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                <i className="bi bi-bezier h4" />
              </span>
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="adminuiux-sidebar-boxed"
              data-bs-toggle="tooltip"
              aria-label="Boxed"
              data-bs-original-title="Boxed"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                <i className="bi bi-box h5" />
              </span>
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="adminuiux-sidebar-boxed adminuiux-sidebar-iconic"
              data-bs-toggle="tooltip"
              aria-label="Iconic+Boxed"
              data-bs-original-title="Iconic+Boxed"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                <i className="bi bi-bounding-box h5" />
              </span>
            </div>
          </div>
        </div>
        <div className="text-center mb-4">
          <a
            href="investment-personalization.html"
            className="btn btn-sm btn-outline-theme"
          >
            More options <i className="bi bi-arrow-right-short" />
          </a>
        </div>
      </div>
    </div>
  </div>
</main>

      </div>
    </>
  );
}